import _ from 'underscore'

const convertToConstants = (root, base = '') => {

    // Array node : convert to object
    if (_.isArray(root)) {
        return _.object(_.map(root, (key) => (
            [key, base + '.' + key]
        )))
    }

    // Object node : convert recursively
    else {
        return _.mapObject(root, (val, key) => (
            convertToConstants(val, base + (base.length ? '.' : '') + key)
        ))
    }
}

const API = [ 'FETCH', 'SUCCESS', 'ERROR' ]
const LCRUD = {
  LIST: API,
  POST: API,
  GET: API,
  PUT: API,
  DELETE: API
}

export default convertToConstants({
  APP: [ 'CHANGEPAGE', 'CLEARERROR', 'SETSTATUS' ],
  AUTH: {
    LOGIN: API,
    LOGOUT: API,
    PASSWORD: API
  },
  BATTERIES:    LCRUD,
  CATEGORIES:   _.extend(
                  {
                    REORDER: API
                  },
                  LCRUD
                ),
  CONTROLS:     {
                  LIST: API,
                  POST: API,
                  GET: {
                    BASIC: API,
                    FULL: API
                  },
                  PUT: API,
                  DELETE: API
                },
  CTRL_PRODS:   {
                  POST: API,
                  GET: API,
                  PUT: API,
                  DELETE: API
                },
  CTRL_GROUPS:  {
                  POST: API,
                  GET: API,
                  PUT: API,
                  DELETE: API,
                  EXECUTE: API
                },
  CTRL_TASKS:   {
                  POST: API,
                  GET: API,
                  PUT: API,
                  DELETE: API
                },
  COLORS:       _.omit(LCRUD, 'GET'),
  DIAMETERS:    LCRUD,
  MAINTENANCES: {
                  LIST: API,
                  POST: API,
                  GET: {
                    BASIC: API,
                    FULL: API
                  },
                  PUT: API,
                  DELETE: API
                },
  EXECUTIONS:   {
                  POST: {
                    P1: API,
                    P2: API
                  },
                  GET: API,
                  PUT: API,
                  DELETE: API
                },
  INVENTORIES:  {
                  LIST: API,
                  POST: {
                    P1: API,
                    P2: API
                  },
                  GET: API,
                  PUT: API,
                  DELETE: API
                },
  PRODUCTS:     {
                  LIST: API,
                  POST: API,
                  GET: {
                    MINIMAL: API,
                    BASIC: API,
                    FULL: API
                  },
                  PUT: {
                    MINIMAL: API,
                    FULL: API
                  },
                  DELETE: API,
                  REORDER: API
                },
  ITEMS:        {
                  POST: API,
                  GET: {
                    BASIC: API,
                    HISTORY: API
                  },
                  PUT: API,
                  DELETE: API
                },
  LOCATIONS:    {
                  LIST: {
                    LINEAR: API,
                    TREE: API
                  },
                  POST: API,
                  GET: {
                    BASIC: API,
                    FULL: API
                  },
                  PUT: API,
                  DELETE: API,
                  REORDER: API
                },
  COMPARTMENTS: {
                  LIST: API
                },
  OWNERS:       LCRUD,
  USERS:        LCRUD,
  PRINT:        {
                  BATTERIES: API,
                  CONTROL: API,
                  CONTROL_GROUP: API,
                  FULL_INVENTORY: API,
                  INVENTORY: API,
                  INVENTORY_TO_FILL: API,
                  OWNER: API,
                  PRODUCT: API,
                  PIPES: API
                }
})



// WEBPACK FOOTER //
// ./src/actions/Types.js